import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Grid, Typography, MenuItem } from '@mui/material'
import Filter from '../filter'
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'
import { useStyles } from './style'
/**
 * Give the user a list of options to choose from
 */
const DropdownFilter = props => {
  const {
    name,
    label,
    options,
    multiple,
    value: selected = [],
    onChange,
    onApply,
    disableApply,
    disabled
  } = props
  const classes = useStyles(props)

  const handleApply = value => onApply({ name, value })

  /* eslint-disable indent */
  const handleClick = value => {
    const newValue = multiple
      ? selected.includes(value)
        ? selected.filter(v => v !== value)
        : [...selected, value]
      : value

    const changed = { name, value: newValue }
    onChange(changed)
    if (!multiple) handleApply(newValue)
  }

  return (
    <Filter
      label={label}
      disabled={disabled || options?.length < 1}
      onApply={() => handleApply(selected)}
      disableApply={disableApply}
      closeOnClick={!multiple}
      classes={{ popover: classes.list, label: classes.label }}
    >
      <div role='menu'>
        {options.map((option, index) => {
          const itemLabelId = `${option.key.replace(/\s/g, '')}-option`
          return (
            <MenuItem
              key={option.key}
              value={option.key}
              className={classes.item}
              onClick={() => handleClick(option.key)}
            >
              <Grid
                container
                justifyContent='space-between'
                alignItems='center'
                wrap='nowrap'
              >
                <Grid container item xs={10} wrap='nowrap' alignItems='center'>
                  {multiple && (
                    <Checkbox
                      icon={<CheckBoxOutlineBlank />}
                      checkedIcon={<CheckBox />}
                      checked={selected.indexOf(option.key) > -1}
                      className={classes.checkbox}
                      inputProps={{ 'aria-labelledby': itemLabelId }}
                    />
                  )}
                  <Typography
                    id={itemLabelId}
                    variant='body2'
                    align='left'
                    noWrap
                    className={classes.label}
                  >
                    {option.key}
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography
                    variant='body2'
                    align='right'
                    className={classes.count}
                  >
                    {option.doc_count}
                  </Typography>
                </Grid>
              </Grid>
            </MenuItem>
          )
        })}
      </div>
    </Filter>
  )
}

DropdownFilter.propTypes = {
  /**
   * Name of the filter
   */
  name: PropTypes.string.isRequired,
  /**
   * Contents of the filter button
   */
  label: PropTypes.string,
  /**
   * Options the user select from
   */
  options: PropTypes.array.isRequired,
  /**
   * Currently selected value(s)
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  /**
   * Set true to enable selection of multiple options (displays checkboxes)
   */
  multiple: PropTypes.bool,
  /**
   * Callback function fired when the selected option is changed.
   */
  onChange: PropTypes.func,
  /**
   *  Callback function fired when the Apply button is clicked.
   *  Passing this prop displays the button.
   */
  onApply: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
}

DropdownFilter.defaultProps = {
  options: [],
  multiple: false,
  onChange: undefined,
  onApply: undefined
}

export default DropdownFilter
